// Compose canonically decomposed Hangul, but never guess a name from loose jamo.
export function normalizeBuyerName(value) {
  return String(value ?? "").normalize("NFC").trim();
}

export function hasIncompleteBuyerName(value) {
  return /[\u1100-\u11ff\u3130-\u318f\ua960-\ua97f\ud7b0-\ud7ff\uffa0-\uffdc\ufffd]/u.test(normalizeBuyerName(value));
}

export function getBuyerDisplayName(value) {
  const name = normalizeBuyerName(value);
  return name && !hasIncompleteBuyerName(name) ? name : "회원";
}

export function validateBuyerName(value) {
  if (!normalizeBuyerName(value)) return "담당자명을 입력해 주세요.";
  if (hasIncompleteBuyerName(value)) return "담당자명에 미완성 한글이 있습니다. 이름을 완성해 주세요.";
  return "";
}
